module.exports = __webpack_public_path__ + "ps.3ac04b1cc2065220c72c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ps.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ps.svg
// module chunks = styles